import { TrashedTicket } from '../types/shift';

const TRASH_KEY = 'noc-shift-trash';
const MAX_TRASH = 100;
const TTL_DAYS = 30;

function pruneExpired(items: TrashedTicket[]): TrashedTicket[] {
  const cutoff = Date.now() - TTL_DAYS * 24 * 60 * 60 * 1000;
  return items.filter((t) => new Date(t.deletedAt).getTime() > cutoff);
}

export function getTrash(): TrashedTicket[] {
  try {
    const raw = localStorage.getItem(TRASH_KEY);
    if (!raw) return [];
    let items: TrashedTicket[] = JSON.parse(raw);
    items = pruneExpired(items);
    localStorage.setItem(TRASH_KEY, JSON.stringify(items));
    return items.sort((a, b) => new Date(b.deletedAt).getTime() - new Date(a.deletedAt).getTime());
  } catch {
    return [];
  }
}

export function addToTrash(item: Omit<TrashedTicket, 'id'>): string {
  const id = crypto.randomUUID();
  const entry: TrashedTicket = { ...item, id };
  try {
    const items = getTrash();
    items.unshift(entry);
    const trimmed = items.slice(0, MAX_TRASH);
    localStorage.setItem(TRASH_KEY, JSON.stringify(trimmed));
  } catch { /* localStorage full */ }
  return id;
}

export function restoreFromTrash(id: string): TrashedTicket | null {
  try {
    const items = getTrash();
    const idx = items.findIndex((t) => t.id === id);
    if (idx === -1) return null;
    const [restored] = items.splice(idx, 1);
    localStorage.setItem(TRASH_KEY, JSON.stringify(items));
    return restored;
  } catch {
    return null;
  }
}

export function permanentlyDelete(id: string): void {
  try {
    const items = getTrash();
    const filtered = items.filter((t) => t.id !== id);
    localStorage.setItem(TRASH_KEY, JSON.stringify(filtered));
  } catch { /* ignore */ }
}

export function clearTrash(): void {
  try {
    localStorage.removeItem(TRASH_KEY);
  } catch { /* ignore */ }
}
